import { Injectable } from '@angular/core';
import {
  AdpCustomer,
  attributesMap,
  attributesPropertiesMap,
  STOCKCART,
  MOVESTOCKLOCATION, CART
} from '../providers/data';
import { CartPage } from '../pages/cart/cart';
import { Headers, RequestOptions } from '@angular/http';
import {IMAGES_BASE_URL} from './config';

import { Storage } from '@ionic/storage';


import {DomSanitizer} from '@angular/platform-browser';
import { CustomerCarts } from './user-cart-provider/user-carts';
import {CONSUMESTOCKCARTManage} from "../providers/data";
@Injectable()
export class ConsumestockcartManager {



  public getCust:any ;
  constructor(private storage:Storage,private sanitizer:DomSanitizer){

  }



  setCustomer(customer){

    if(CONSUMESTOCKCARTManage.customer == null){

      CONSUMESTOCKCARTManage.customer = customer;
    }else{
      this.clearCartProducts();
      CONSUMESTOCKCARTManage.customer = customer;
    }
    //alert(JSON.stringify(CONSUMESTOCKCARTManage));
  }


  clearCart(){
    CONSUMESTOCKCARTManage.items = [];
  }


  addToCartNew(product) {
    if(!Number(product.quantityReceived)){
      product.quantityReceived = 0;
    }

    CONSUMESTOCKCARTManage.items.push(product);
    this.persistOrderLocal();
  }
  addProductToCart(product) {
    var index= CONSUMESTOCKCARTManage.items.map(function(x) {return x.productLocationIdWithCode; }).indexOf(product.productLocationIdWithCode);
    if (index != -1) {
      if(CONSUMESTOCKCARTManage.items[index].quantityReceived < CONSUMESTOCKCARTManage.items[index].quantityRemaining)

      {
        if (Number(product.minOrder) != 0 && product.multipleOfMinimumOrderFlag === 1) {
          CONSUMESTOCKCARTManage.items[index].quantityReceived += Number(product.minOrder);
        }  else if (Number(product.minOrder) != 0 && CONSUMESTOCKCARTManage.items[index].quantityReceived === 0) {
          CONSUMESTOCKCARTManage.items[index].quantityReceived += Number(product.minOrder);
        } else {
          CONSUMESTOCKCARTManage.items[index].quantityReceived++;
        }
      }
      // CONSUMESTOCKCARTManage.items[index].quantityReceived++;
      this.persistOrderLocal();
    } else {
      console.log("INels " + product.quantityReceived)
      console.log("INelseeeeeeee " + Number(product.quantityReceived))
      console.log("INelseeeeeeee " + Number(product.minOrder))
      if (Number(product.quantityReceived) != 0) {
        if (Number(product.minOrder) != 0) {
          product.quantityReceived = Number(product.minOrder);
        } else {
          product.quantityReceived = Number(product.quantityReceived);
        }
        // product.quantityReceived = Number(product.quantityReceived);
      } else {
        product.quantityReceived = 0;
      }
      this.addToCartNew(product);
    }
  }

  // addProductToCartPopup(product) {
  //   product.quantity++;
  //   this.persistOrderLocal();
  //
  //   if (Number(product.quantity) != 0) {
  //     product.quantity = Number(product.quantity);
  //   } else {
  //     product.quantity = 0;
  //   }
  //
  // }

  // update Cart
  updateCartNew(product) {



    if(Number(product.quantityReceived) < Number(product.quantityRemaining)){
      console.log("INsidde vvvvv")
      if(product.quantityReceived < 0) {
        product.quantityReceived = 0
      }


        if(Number(product.minOrder) != 0 && product.multipleOfMinimumOrderFlag === 1 && Number(product.quantityReceived) > Number(product.minOrder)){
          product.quantityReceived = this.checkIfQuantityIsMultipleOfMinimumOrder(Number(product.minOrder),Number(product.quantityReceived) )

        }else if(Number(product.quantityReceived) < Number(product.minOrder)){
          if (Number(product.minOrder) != 0) {
            // if (Number(product.quantityReceived) < Number(product.minOrder)) {
              product.quantityReceived = Number(product.minOrder);
            // }
          } else {
            product.quantityReceived = 1;
          }
        }
      else{
          product.quantityReceived = Number(product.quantityReceived);
        }

      // }

    }else {
      product.quantityReceived = product.quantityRemaining
    }


    var index= CONSUMESTOCKCARTManage.items.map(function(x) {return x.productLocationIdWithCode; }).indexOf(product.productLocationIdWithCode);
    if (index != -1) {
      //CONSUMESTOCKCARTManage.items[index].quantity++;
    } else {

      this.addToCartNew(product);
    }
    this.persistOrderLocal();
    //alert(JSON.stringify(CONSUMESTOCKCARTManage));
  }

  checkIfQuantityIsMultipleOfMinimumOrder(minimumQuantity, quantity){
    let modulus = quantity % minimumQuantity;
    if(modulus === 0 ){
      return quantity;
    }else {
      return quantity - modulus;
    }
  }

  updateCartNewPopup(product) {


    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }

      }

    }


    var index= CONSUMESTOCKCARTManage.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      //CONSUMESTOCKCARTManage.items[index].quantity++;
    } else {

      // this.addToCartNew(product);
    }
    this.persistOrderLocal();
    //alert(JSON.stringify(CONSUMESTOCKCARTManage));
  }
  // Remove One
  // removeOneNew(product) {
  //   if(product.quantityReceived > 0)
  //   product.quantityReceived--;
  //
  // }

  removeOneNew(product) {
    var index= CONSUMESTOCKCARTManage.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(product.multipleOfMinimumOrderFlag === 1 && CONSUMESTOCKCARTManage.items[index].quantityReceived > Number(product.minOrder)){
        CONSUMESTOCKCARTManage.items[index].quantityReceived -=  Number(product.minOrder)
      }
      else if(CONSUMESTOCKCARTManage.items[index].quantityReceived > Number(product.minOrder)){
        CONSUMESTOCKCARTManage.items[index].quantityReceived--;
        this.persistOrderLocal();
      }else{
        CONSUMESTOCKCARTManage.items[index].quantityReceived = 0;
        // this.removeNew(index);

      }

    }
  }

  // removeOneNewPopup(product) {
  //   var index= MOVESTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
  //   if (index != -1) {
  //     MOVESTOCKCART.items[index].quantity--;
  //     this.persistOrderLocal();
  //
  //   }
  // }

  // Remove All
  removeAll(product) {
    var index= CONSUMESTOCKCARTManage.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(CONSUMESTOCKCARTManage.items[index].quantity >= 1){
        CONSUMESTOCKCARTManage.items[index].quantity = 0;
      }
    }
    this.persistOrderLocal();
  }


  // Remove Item
  removeNew(index: number): void {

    CONSUMESTOCKCARTManage.items.splice(index, 1);
    this.persistOrderLocal();
  }

  deleteProductFromCart(product){
    this.removeAll(product);
    var index= CONSUMESTOCKCARTManage.items.map(function(x) {return x.productLocationIdWithCode; }).indexOf(product.productLocationIdWithCode);
    if (index != -1) {
      this.removeNew(index);
    }
  }

  genrateOrder(status){
    let total = 0;
    let orderProducts = [];
    let expectedShipmentDate = CONSUMESTOCKCARTManage.shipDate;
    for(let item of CONSUMESTOCKCARTManage.items){

      if(this.discountCheck(item.discountPrice)){
        total =  total + (Number(item.discountPrice) * Number(item.quantity));
      }else{
        total =  total + (Number(item.price) * Number(item.quantity));
      }

      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
        "expectedShipmentDate": expectedShipmentDate,
        "attributeSearch":item.attributeSearch
      };


      orderProducts.push(orderDetailDTOs);
    }

    if(CONSUMESTOCKCARTManage.customer.locationsDTOs.length>0){
      for(let locationId in CONSUMESTOCKCARTManage.customer.locationsDTO){
        CONSUMESTOCKCARTManage.customer.locationsDTO[locationId].createdAt = "";
        CONSUMESTOCKCARTManage.customer.locationsDTO[locationId].updatedAt = "";
      }
    }

    CONSUMESTOCKCARTManage.customer.customerJson = "";

    let order = {
      "id":CONSUMESTOCKCARTManage.orderId,
      "orderTitle": this.getOrderTitle(),
      "salesManId":CONSUMESTOCKCARTManage.user.id,
      "orderMessage":CONSUMESTOCKCARTManage.orderMessage,
      "expectedShipmentDate": CONSUMESTOCKCARTManage.expectedShipmentDate,
      "totalAmount":""+total.toFixed(2),
      "totalTexAmount":"10",
      "orderStatus":status,
      "customerDTO":CONSUMESTOCKCARTManage.customer,
      "orderDetailDTOs": orderProducts,
      "shippingServiceName":CONSUMESTOCKCARTManage.shippingServiceName,
      "shippingServiceValue":CONSUMESTOCKCARTManage.shippingServiceId
    };
    //this.gVLogger.log(JSON.stringify(order));

    return order;

  }

  setLocation(location){
    MOVESTOCKLOCATION.productsLocation = location;
  }

  receiveStock(){

    var productsDTOList = [];
    for(let item of CONSUMESTOCKCARTManage.items){

      if(item.quantityReceived > 0){
        for(let loc of item.productInventoryLocationsDTO){
          if(loc.quantityRemaining >= item.quantityReceived){
              loc.quantityReceived = item.quantityReceived
              break;
          }else {
            loc.quantityReceived = loc.quantityRemaining
            item.quantityReceived = item.quantityReceived - loc.quantityRemaining
          }
        }
      }


      // let productInventoryLocationsDTO = [{
      //   inventoryLocationById : {locationCode:""},
      //   quantityReceived : item.quantityReceived,
      //   quantityRemaining : item.quantityRemaining,
      //   productConditionCode : 0,
      //   productCondition : "Good"
      // }]

      // item.productInventoryLocationsDTO = productInventoryLocationsDTO
      productsDTOList.push(item);
    }



    // CONSUMESTOCKCARTManage.customer.customerJson = "";


    return productsDTOList;

  }

  clearCartProducts(){
    for(let product of CONSUMESTOCKCARTManage.items){
      this.removeAll(product);
    }
    CONSUMESTOCKCARTManage.items = [];
  }

  getProductsCount(){
    return CONSUMESTOCKCARTManage.items.length;
  }

  getSalesManId(){
    return CONSUMESTOCKCARTManage.user.id;
  }
  getCustomerName(){
    if(CONSUMESTOCKCARTManage.customer !=null){

      return CONSUMESTOCKCARTManage.customer.name;
    }else{
      return null;
    }
  }

  getSalesPerson(){
    return CONSUMESTOCKCARTManage.user;

  }

  getADPCustomerUUID(){
    if(CONSUMESTOCKCARTManage.user && CONSUMESTOCKCARTManage.user.adpCustomerInfo){
      return CONSUMESTOCKCARTManage.user.adpCustomerInfo.uuid;
    }else{
      return "";
    }
  }

  setShipDate(shipDate){
    CONSUMESTOCKCARTManage.expectedShipmentDate = shipDate ;
  }
  // getShipDate(){
  //   return MOVESTOCKCART.expectedShipmentDate;
  // }

  // setOdId(odId){
  //   MOVESTOCKCART.odId = odId;
  // }

  // getOdId(){
  //   return MOVESTOCKCART.odId;
  // }

  // setItems(productsList){
  //   MOVESTOCKCART.items = productsList;
  // }
  setOrderId(orderId){
    CONSUMESTOCKCARTManage.orderId = orderId ;
  }
  setOrderMessage(orderMessage){
    CONSUMESTOCKCARTManage.orderMessage = orderMessage;
  }
  // getOrderMessage(){
  //   return MOVESTOCKCART.orderMessage;
  // }
  //
  // getExpectedSipDate(){
  //   return MOVESTOCKCART.expectedSipDate;
  // }

  getItems(){
    return CONSUMESTOCKCARTManage.items;
  }


  getCustomerID(){
    if(CONSUMESTOCKCARTManage.customer!=null){
      return CONSUMESTOCKCARTManage.customer.id;
    }else{
      return false;
    }
  }


  // getSelectedCustomer(){
  //   return MOVESTOCKCART.customer;
  // }

  setOrderTitle(orderTitle){
    CONSUMESTOCKCARTManage.orderTitle = orderTitle;
  }

  getOrderTitle(){
    return CONSUMESTOCKCARTManage.orderTitle;
  }
  getOrderId(){
    return CONSUMESTOCKCARTManage.orderId;
  }

  persistOrderLocal(){
    // TODO: Store the list of Cart against their user/sales persons
    let itemQuantityStatus = false;
    for(let product of CONSUMESTOCKCARTManage.items){
      if(product.quantityReceived > 0){
        itemQuantityStatus = true;
        break;
      }
    }

    if(Number(CONSUMESTOCKCARTManage.items.length) > 0 && itemQuantityStatus){
      this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),CONSUMESTOCKCARTManage);

    }else{
      this.unPersistOrderLocal();
    }
//this.gVLogger.log(MOVESTOCKCART);
  }
  unPersistOrderLocal(){
    this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
  }

  // getPersistedOrderLocal(){
  //
  //   return this.storage.get(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
  // }

  // setCartFull(cartTemp){
  //   MOVESTOCKCART.items = cartTemp.items;
  //   MOVESTOCKCART.orderId = cartTemp.orderId;
  //   MOVESTOCKCART.orderMessage = cartTemp.orderMessage;
  //   MOVESTOCKCART.customer = cartTemp.customer;
  //   MOVESTOCKCART.orderTitle = cartTemp.orderTitle;
  //   // this.gVLogger.log("Cart Replaced...",cartTemp);
  // }


  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

  getOrderStatus(){
    return CONSUMESTOCKCARTManage.orderStatus;
  }

  setOrderStatus(status){
    CONSUMESTOCKCARTManage.orderStatus = status;
  }


  makeImageURL(dimensions,item){
    console.log("Product images url " + IMAGES_BASE_URL.imageBaseUrl + this.getSupplierUuid() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension);
    // return  IMAGES_BASE_URL + this.getADPCustomerUUID() +
    //   "/products/" +
    //   dimensions + "/"+
    //   item.productImagesDTO[0].name+
    //   "-" +
    //   dimensions +
    //   "." +
    //   item.productImagesDTO[0].extension;

    return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getSupplierUuid() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension;
  }

  getSupplierUuid(){
    return AdpCustomer.AdpCustomerInfo.uuid;
  }

  // setShippingServiceId(id){
  //   MOVESTOCKCART.shippingServiceId = id;
  // }
  // getShippingServiceId(){
  //   return MOVESTOCKCART.shippingServiceId;
  // }


  // setAdpCustomerInfo(adpCustomerInfo){
  //   AdpCustomer.AdpCustomerInfo = adpCustomerInfo;
  // }

  getAdpCustomerInfo(){
    return AdpCustomer.AdpCustomerInfo;
  }


  // sanitizeUrl(url){
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }



  // addToAttributeMap(key,value){
  //   attributesMap[key+""] = ""+value;
  // }

  getAttributeValue(key){
    let res = attributesMap[key+""];
    if(res === undefined){
      return "-"
    }else{
      return res;
    }
  }


  // addAttributePropertiesMap(key,val){
  //   attributesPropertiesMap.set(key+"", val);
  // }
  //
  // getAllAttributesPropertiesMap(){
  //   return attributesPropertiesMap;
  // }

  replaceDoublePipe(str){
    return str.split("||").join(" ");
  }

  ConvertToCSV(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "";
    for (let index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line != '') line += ',';
        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/providers/consumestockcart-manager.ts